import { createSelector } from '@app/utils/createSelector'

import { callApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

/** No token, unlike the guest session: a signed-in user authenticates the socket with the session JWT. */
export type SupportChatSession = {
  channelId: string
}

const supportChatSessionSlice = createReduxSlice<SupportChatSession>('support_chat_session')

export const supportChatSessionSelector = createSelector([supportChatSessionSlice.selector], (slice): SupportChatSession | null => slice ?? null)

export const hasSupportChatSessionSelector = createSelector([supportChatSessionSelector], session => session !== null)

/** Idempotent server-side, so a second open reuses the channel rather than raising another. */
export function ensureSupportChatSession() {
  return createThunk(async (dispatch, getState): Promise<SupportChatSession> => {
    const current = supportChatSessionSelector(getState())
    if (current) return current

    const { postSupportSession } = await import('@app/packages/api/v3/actions/support')
    const response = await dispatch(callApi(postSupportSession()))

    const session: SupportChatSession = { channelId: response.data.attributes.channel_id }
    dispatch(supportChatSessionSlice.set(session))

    return session
  })
}
